const routerLocales = {
  enUS: '',
  esLA: '/es',
  esES: '/es-es',
  ptBR: '/pt-br',
  ptPT: '/pt-pt',
  frFR: '/fr',
  deDE: '/de',
  arME: '/ar',
  itIT: '/it',
  ruRU: '/ru',
  hiIN: '/hi',
  idID: '/id',
};

const helpCenterLocales = {
  enUS: '/en-us',
  esLA: '/es',
  esES: '/es',
  ptBR: '/pt',
  ptPT: '/pt',
  frFR: '/fr',
  deDE: '/de',
  arME: '/ar',
  itIT: '/it',
  ruRU: '/ru',
  hiIN: '/en-us',
  idID: '/en-us',
};

const unsupportedHelpCenterLocales = ['hiIN', 'idID'];

const transifexLocales = {
  enUS: 'en_US',
  esLA: 'es_419',
  esES: 'es_ES',
  ptBR: 'pt_BR',
  ptPT: 'pt_PT',
  frFR: 'fr_FR',
  deDE: 'de_DE',
  arME: 'ar_SA',
  itIT: 'it_IT',
  ruRU: 'ru_RU',
  hiIN: 'hi_IN',
  idID: 'id_ID',
};

const etpLocales = {
  enUS: 'en-US',
  esLA: 'es-419',
  esES: 'es-ES',
  ptBR: 'pt-BR',
  ptPT: 'pt-PT',
  frFR: 'fr-FR',
  deDE: 'de-DE',
  arME: 'ar-SA',
  itIT: 'it-IT',
  ruRU: 'ru-RU',
  id: 'id-ID',
};

module.exports = {
  routerLocales,
  helpCenterLocales,
  unsupportedHelpCenterLocales,
  transifexLocales,
  etpLocales,
};
